import React, { Component, createRef } from "react";
import { Container } from "reactstrap";

import { connect } from "react-redux";
import { getLocations, setSearchQuery, setPage } from "../../actions/locations";

import PageTransition from "../styles/PageTransition";
import ContainerHeader from "../styles/ContainerHeader";
import PanelNavs from "../PanelNavs";
import PanelHead from "../PanelHead";
import PageMeta from "../PageMeta";
import LoaderWrapper from "../styles/LoaderWrapper";
import Loader from "../Loader";
import Paginator from "../Paginator";
import LocationsList from "./LocationsList";

class LocationsContainer extends Component {
  searchField = createRef();

  handleSubmitData = async () => {
    await this.props.getLocations(this.props.filters);
  };

  componentDidMount() {
    this.handleSubmitData();
  }

  handleSearch = async query => {
    await this.props.setSearchQuery(query);
    this.handleSubmitData();
  };

  handleReload = async () => {
    this.searchField.current.state.query = "";
    await this.props.setSearchQuery("");
    this.handleSubmitData();
  };

  handlePaginator = async page => {
    await this.props.setPage(page);
    this.handleSubmitData();
  };

  render() {
    const { meta, filters, locations, loading, links } = this.props;

    return (
      <PageTransition>
        <Container>
          <fieldset disabled={loading} aria-busy={loading}>
            <ContainerHeader>
              <PanelNavs title="Barrios" add={true} url="/locations/add" />
              <PanelHead
                handleSearch={this.handleSearch}
                handleReload={this.handleReload}
                refe={this.searchField}
                loading={loading}
              />
              <PageMeta {...meta} currentPage={filters.page} />
            </ContainerHeader>

            {loading ? (
              <LoaderWrapper>
                <Loader noBg={true} />
              </LoaderWrapper>
            ) : (
              <LocationsList locations={locations} />
            )}

            {locations.length > 0 && !loading && (
              <Paginator
                currentPage={filters.page}
                first={links.first}
                last={links.last}
                next={links.next}
                prev={links.prev}
                handlePaginator={this.handlePaginator}
              />
            )}
          </fieldset>
        </Container>
      </PageTransition>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.locations.loading,
  locations: state.locations.locations,
  meta: state.locations.meta,
  filters: state.locations.filters,
  links: state.locations.links
});

export default connect(
  mapStateToProps,
  {
    getLocations,
    setSearchQuery,
    setPage
  }
)(LocationsContainer);
